// Đổi HIỂN THỊ "Hoạt động <số La Mã/số>" → "Phiếu học tập <số>".
// CHỈ đổi lúc hiển thị (viewer + builder) — KHÔNG đụng dữ liệu đã lưu / Word / cách AI sinh.
const ROMAN: Record<string, number> = {
  i: 1, ii: 2, iii: 3, iv: 4, v: 5, vi: 6, vii: 7, viii: 8, ix: 9, x: 10, xi: 11, xii: 12,
}

export function worksheetLabel(text?: string): string {
  if (!text) return text || ''
  return text.replace(/\bHo[ạa]t\s*đ[ộo]ng\s+([ivxIVX]+|\d+)/gu, (_m, g) => {
    const key = String(g).toLowerCase()
    const n = ROMAN[key] ?? (/^\d+$/.test(key) ? Number(key) : 0)
    return `Phiếu học tập ${n || g}`
  })
}
